import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M27.9399 25.78C27.9399 25.78 13.5199 25.67 11.0999 19.5C8.68986 13.36 13.5199 8.60001 18.6999 8.60001C18.6999 8.60001 21.0099 1 28.0599 1C35.1099 1 36.3199 6.61002 36.3199 6.61002C36.3199 6.61002 42.0099 2.32001 46.0099 5.29001C50.2999 8.48001 47.5499 13.88 47.5499 13.88C47.5499 13.88 54.4299 14.19 53.2699 20.27C51.9499 27.21 36.5399 24.45 36.0999 27.1L27.9399 25.78Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M47.5399 7.50008C47.5399 7.50008 35.3199 6.2901 32.1299 26.7701"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M30.6999 1.89014C30.6999 1.89014 27.6199 9.71013 30.5899 24.5701"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M20.3499 4.96997C20.3499 4.96997 26.2999 6.86 27.8399 25.34"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.02 13.31C12.02 13.31 21.46 11.7399 26.91 25.4399"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M52.7099 16.53C52.7099 16.53 44.5599 13.45 34.8799 25.12"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M41.8838 23.3004C41.7679 23.3677 41.6533 23.4366 41.5401 23.507C41.6471 23.4347 41.7553 23.3653 41.8657 23.2995C42.0209 23.2071 42.1775 23.1182 42.3355 23.0331C42.1837 23.1199 42.0331 23.209 41.8838 23.3004Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M22.0767 22.7847C22.1885 22.8684 22.2989 22.9544 22.4078 23.0426C22.4903 23.1149 22.5716 23.1879 22.6518 23.2619C22.572 23.1926 22.4917 23.1241 22.4107 23.0565L22.4096 23.0555C22.2995 22.9641 22.1886 22.8738 22.0767 22.7847Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M56.7001 35.8501C51.2901 29.0901 39.0801 25.0901 31.9801 25.0901C24.8801 25.0901 12.5601 29.0901 7.15012 35.8501C-2.53988 47.9601 4.0701 74.6001 4.0701 74.6001C4.0701 74.6001 4.73009 53.0201 12.0001 46.6401C18.1901 41.2001 23.8701 43.2901 31.9301 43.2901C39.9901 43.2901 45.6701 41.2101 51.8601 46.6401C59.1301 53.0301 59.7901 74.6001 59.7901 74.6001C59.7901 74.6001 66.3901 47.9601 56.7001 35.8501Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M25.3603 25.6702C25.3603 25.6702 22.8802 31.2802 26.3502 43.3402"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M17.7601 28.1501C17.7601 28.1501 13.8001 34.4301 16.7701 43.8401"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M14.2901 29.9602C14.2901 29.9602 9.01017 35.4102 11.1502 46.9702"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.81021 35.8501C6.81021 35.8501 1.25023 47.1301 6.20023 58.8601"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M38.5002 25.6702C38.5002 25.6702 40.9803 31.2802 37.5103 43.3402"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M46.0903 28.1501C46.0903 28.1501 50.0503 34.4301 47.0803 43.8401"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M49.5603 29.9602C49.5603 29.9602 54.8403 35.4102 52.7003 46.9702"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M57.0503 35.8501C57.0503 35.8501 62.6103 47.1301 57.6603 58.8601"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
